'use client';

import { useEffect, useRef, useState } from 'react';
import { usePathname } from 'next/navigation';
import s from './Independence80Toast.module.css';

/*
 * TEMPORARY — India Independence Day 80 campaign.
 * Centered popup on inner pages for ~4.5s, then fades out.
 * Homepage keeps its own persistent badge — skip the popup there.
 * Remove this component + its CSS, and the layout.js mount, when the campaign ends.
 */

const VISIBLE_MS = 4500;
const EXIT_MS = 420;

function isHomepage(pathname) {
  return pathname === '/' || pathname === '';
}

export default function Independence80Toast() {
  const pathname = usePathname();
  const [phase, setPhase] = useState('gone');
  const hideRef = useRef();
  const goneRef = useRef();

  useEffect(() => {
    if (isHomepage(pathname)) {
      setPhase('gone');
      return undefined;
    }
    setPhase('in');
    hideRef.current = setTimeout(() => setPhase('out'), VISIBLE_MS);
    goneRef.current = setTimeout(() => setPhase('gone'), VISIBLE_MS + EXIT_MS);
    return () => {
      clearTimeout(hideRef.current);
      clearTimeout(goneRef.current);
    };
  }, [pathname]);

  function dismiss() {
    if (phase !== 'in') return;
    clearTimeout(hideRef.current);
    clearTimeout(goneRef.current);
    setPhase('out');
    goneRef.current = setTimeout(() => setPhase('gone'), EXIT_MS);
  }

  if (isHomepage(pathname) || phase === 'gone') return null;

  return (
    <div
      className={`${s.overlay} ${phase === 'out' ? s.overlayOut : ''}`}
      role="status"
      aria-live="polite"
    >
      <div className={s.card}>
        <img
          className={s.badge}
          src="/campaigns/independence-80/celebrating-banner.png"
          alt="Celebrating 80 years of Independence"
          width={680}
          height={160}
          decoding="async"
        />
        <button
          type="button"
          className={s.close}
          aria-label="Close"
          onClick={dismiss}
        >
          <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
            <path
              d="M1.5 1.5l9 9M10.5 1.5l-9 9"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.75"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
